// const frontendCardDescription: string = `I'm an experienced software engineer who constantly seeks out innovative solutions to everyday problems.
//  In my years in this industry, I've honed my analytical thinking and collaboration skills, and I love working with a team. I've also had the 
//  opportunity to serve as the software engineer lead for three projects with First Technology`;

const reactCardDescription: string = `I am an expert in the latest React hooks and best practices, and I am proficient in JavaScript and TypeScript. I have experience with React integrations, building effective and efficient React components, and delivering high performant React applications. I have also developed multi-tenant applications, implemented application with React Context Store, Redux, and Redux toolkit, and architected React applications.
In addition to my technical skills, I am also a leader and mentor. I have experience leading teams, collaborating with other teams, and involving stakeholders and business owners directly. I have also mentored and trained engineers for React and front-end development.
I am passionate about building high-quality, performant, and user-friendly React applications. I am also committed to helping others learn and grow.`;

const reactTechnologiesAndTools: string[] = [
 "React",
 "Next.js",
 "Redux toolkit",
 "Redux",
 "JavaScript",
 "TypeScript",
 "Stripe",
 "Twilio",
 "Team leadership",
 "Collaboration",
 "Mentoring",
 "Less",
 "Sass",
 "Ant Design",
 "Material UI",
 "React testing library",
 "Jest",
 "Cypress",
]

export { reactCardDescription, reactTechnologiesAndTools };
